<div class="card-wrapper">
  <div class="selectable-card">
    <!-- <app-usf-checkbox
      [isSelected]="isOrderSelected === vm"
      (click)="onOrderSelection(vm, index)"
    ></app-usf-checkbox> -->

    <ion-radio
      mode="md"
      slot="end"
      [value]="vm"
      (click)="onOrderSelection(vm)"
    ></ion-radio>
  </div>
  <ion-card data-cy="add-to-orders-section" class="add-orders">
    <div class="customer-info" *ngIf="vm?.orderHeader?.departmentNumber > 0">
      <span
        >{{ 'i18n.orderPage.addToOrderModal.deptNumber' | translate }} ({{
          vm?.orderHeader?.departmentNumber
        }})</span
      >
    </div>
    <div class="order-status-info">
      <div>
        <div
          [ngClass]="[
            vm?.orderStatusDetails?.displayType === DisplayType.ORDER_ERROR
              ? 'red-text'
              : '' ||
                vm?.orderStatusDetails?.displayType === DisplayType.SUBMITTED
              ? 'green-text'
              : '' ||
                vm?.orderStatusDetails?.displayType ===
                  DisplayType.SUBMITTED_WITH_EXCEPTIONS
              ? 'red-text'
              : '' ||
                vm?.orderStatusDetails?.displayType ===
                  DisplayType.SUBMISSION_ERROR
              ? 'red-text'
              : ''
          ]"
        >
          {{ vm?.orderStatusDetails?.shortTitle }}
        </div>

        <!-- SHIPPING TYPE -->
        <ng-container>
          <span class="shipping-text" data-cy="add-to-order-usf-shipping-text"
            >&nbsp;|&nbsp;{{
              'i18n.home.recentOrdersTile.usFoodsDelivery' | translate
            }}</span
          >
          <!-- Use for Direct Shipments -->
          <!-- <span
            class="shipping-text"
            data-cy="recent-order-direct-shipping-text"
            >&nbsp;|&nbsp;<img
              src="assets/icon/direct-no-outline.svg"
              class="direct-icon"
              alt="Direct Order"
              height="10"
            />
            {{ 'i18n.orderStatusPage.shipping' | translate }}
          </span> -->
        </ng-container>
      </div>
    </div>
    <div class="order-detail-info">
      <div class="order-number">
        <ng-container *ngIf="vm?.orderHeader?.tandemOrderNumber > 0"
          >{{ 'i18n.orderPage.addToOrderModal.orderNumber' | translate }}
          {{ vm?.orderHeader?.tandemOrderNumber }}</ng-container
        >
      </div>
      <div class="delivery-date">
        <!--Start: Delivery ETA-->
        <div
          *ngIf="vm.hasETADetails; else checkETARouteDetails"
          data-cy="open-order-vm-link"
          class="delivery-date"
        >
          <div
            *ngIf="
              !!vm?.orderHeader?.etaRangeMaximum &&
                !!vm?.orderHeader?.etaRangeMinimum;
              else wmtDate
            "
          >
            <span
              >{{ 'i18n.orderPage.addToOrderModal.eta' | translate }}
              {{
                vm?.orderHeader?.deliveryEta
                  | date: 'M/d':vm.selectedOrderCustomer?.timeZone
              }},
              {{
                vm?.orderHeader?.etaRangeMinimum
                  | timezoneDate: 'h:mm a':vm.selectedOrderCustomer?.timeZone
              }}
              -
              {{
                vm?.orderHeader?.etaRangeMaximum
                  | timezoneDate
                    : 'h:mm a'
                    : vm.selectedOrderCustomer?.timeZone
                    : true
              }} </span
            ><br />
            <span
              class="date"
              *ngIf="
                !!vm?.orderHeader?.customerStop && !!vm?.orderHeader?.etaRoute
              "
            >
              {{ 'i18n.orderStatusPage.youAreStop' | translate }}
              {{ vm?.orderHeader?.customerStop }}
              {{ 'i18n.orderStatusPage.onRoute' | translate }}
              {{ vm?.orderHeader?.etaRoute }}</span
            ><br />
            <span class="date" *ngIf="!!vm?.orderHeader?.currentStop"
              >{{ 'i18n.orderStatusPage.truckAtStop' | translate
              }}{{ vm?.orderHeader?.currentStop }}</span
            >
          </div>
          <ng-template #wmtDate>
            <span class="date"
              >{{ 'i18n.orderPage.addToOrderModal.eta' | translate }}
              {{ vm?.wmtDeliveryDate?.deliveryDate | date: 'M/d':'UTC' }},
              {{
                vm?.wmtDeliveryDate?.start
                  | timezoneDate: 'h:mm a':vm.selectedOrderCustomer?.timeZone
              }}
              -
              {{
                vm?.wmtDeliveryDate?.end
                  | timezoneDate
                    : 'h:mm a'
                    : vm.selectedOrderCustomer?.timeZone
                    : true
              }}
            </span>
          </ng-template>
        </div>
        <ng-template #checkETARouteDetails>
          <div *ngIf="!vm?.orderHeader?.orderDelivered" class="delivery-date">
            <span *ngIf="vm?.orderHeader?.deliveryEta; else deliveryDateAsETA">
              {{ 'i18n.orderPage.addToOrderModal.eta' | translate }}
              {{
                vm.orderHeader?.deliveryEta
                  | date: 'M/d':vm.selectedOrderCustomer?.timeZone
              }}
            </span>
            <ng-template #deliveryDateAsETA>
              <span
                *ngIf="
                  isValidDate(vm.deliveryDate) &&
                    !(
                      vm?.orderHeader?.orderType === 'VS' &&
                      (!!vm?.orderHeader?.orderTracking?.length ||
                        vm?.orderHeader?.trackingAvailable)
                    );
                  else deliveryDateAsETANotApplicable
                "
              >
                {{ 'i18n.orderPage.addToOrderModal.eta' | translate }}
                {{ vm.deliveryDate | date: 'M/d':'GMT' }}
              </span>
              <ng-template #deliveryDateAsETANotApplicable>
                <span
                  *ngIf="
                    !(
                      vm?.orderHeader?.orderType === 'VS' &&
                      (!!vm?.orderHeader?.orderTracking?.length ||
                        vm?.orderHeader?.trackingAvailable)
                    )
                  "
                  >{{ 'i18n.orderPage.addToOrderModal.eta' | translate }}
                  {{ 'i18n.orderStatusPage.notApplicable' | translate }}
                </span>
              </ng-template>
            </ng-template>
            <br />
            <span
              *ngIf="
                !!vm?.orderHeader?.customerStop && !!vm?.orderHeader?.etaRoute
              "
            >
              {{ 'i18n.orderStatusPage.youAreStop' | translate
              }}{{ vm?.orderHeader?.customerStop }}
              {{ 'i18n.orderStatusPage.onRoute' | translate }}
              {{ vm?.orderHeader?.etaRoute }} </span
            ><br />
            <span *ngIf="!!vm?.orderHeader?.currentStop">
              {{ 'i18n.orderStatusPage.truckAtStop' | translate
              }}{{ vm?.orderHeader?.currentStop }}
            </span>
          </div>
        </ng-template>
        <!--END: Delivery ETA -->
      </div>
      <div class="order-detail-info_labels">
        <div data-cy="add-to-orders-placed-label" class="po-number-text">
          {{ 'i18n.orderPage.addToOrderModal.poNumberShort' | translate }}
        </div>
        <div data-cy="add-to-orders-each-cases-label">
          {{ 'i18n.orderPage.addToOrderModal.eachesCases' | translate }}
        </div>
        <div data-cy="add-to-orders-total-label">
          {{ 'i18n.home.recentOrdersTile.total' | translate }}
        </div>
      </div>
      <div class="order-detail-info_text">
        <div data-cy="add-to-orders-placed-text" class="po-number-text">
          {{ vm?.orderHeader?.purchaseOrderNumber || '-' }}
        </div>
        <div data-cy="add-to-orders-each-cases-text">
          <ng-container
            >{{ vm?.orderHeader?.totalUnits || 0 }} CS /
            {{ vm?.orderHeader?.totalEaches || 0 }} EA
          </ng-container>
        </div>
        <div data-cy="add-to-orders-total-text">
          <ng-container
            >{{ calculateTotalPrice(vm?.orderHeader) || 0 | currency }}
          </ng-container>
        </div>
      </div>
    </div>
  </ion-card>
</div>
